import { faHandsPraying, faBookOpen } from "@fortawesome/free-solid-svg-icons"

export const applicationName = "MaroniteHub"

export const DEFAULT_FONT_SIZE = 20;
export const DEFAULT_COLUMNS = 1;

export const navigationLinks = [
  {
    icon: faHandsPraying,
    label: 'Faith',
    href: '/bible',
    selected: (url: string) => url.startsWith('/bible')
  },
  // {
  //   icon: faMapLocationDot,
  //   label: 'Church Map',
  //   href: '/church-map',
  //   selected: (url: string) => url.startsWith('/church-map')
  // },
  // {
  //   icon: faUserTie,
  //   label: 'Professionals',
  //   href: '/professionals',
  //   selected: (url: string) => url.startsWith('/professionals')
  // },
]

export const bibleNavigationLinks = [
  {
    icon: faBookOpen,
    label: 'Bible',
    href: '/bible',
    selected: (url: string) => url.startsWith('/bible')
  },
  // {
  //   icon: faCalendarDay,
  //   label: 'Readings',
  //   href: '/bible/readings',
  //   selected: (url: string) => url.startsWith('/bible/readings')
  // },
  // {
  //   icon: faCalendarWeek,
  //   label: 'Divine Office',
  //   href: '/bible/divine-office',
  //   selected: (url: string) => url.startsWith('/bible/divine-office')
  // },
]

const defaultTheme = {
  '--color-white': '#FFFFFF',
  '--color-primary': '#9C5C1C',
  '--color-wood': '#783F13',
  '--color-borderColor': '#451004',
  '--color-dark-primary': '#451004',
  '--color-secondary': '#DBB86B',
  '--color-navigation-background': '#C5974C',
  '--color-light': '#E7CF9C',
  '--color-black': '#090c0d',
  '--color-background': '#FBF7EF',
  '--color-verse-index': '#565f69',

  '--color-button-background': '#E7CF9C',
  '--color-button-text': '#451004',
  '--color-button-border': '#451004',

  '--active-button-background': '#451004',
  '--active-button-text': '#E7CF9C',
  '--active-button-border': '#E7CF9C',

  '--color-checkbox-border': '#451004',
  '--color-checkbox-background': '#9C5C1C',
  '--color-checkbox-accent': '#451004',

  '--color-verse-underline': '#090c0d',
}

const darkTheme = {
  '--color-white': '#090c0d',
  '--color-primary': '#DBB86B',
  '--color-wood': '#C5974C',
  '--color-borderColor': '#E7CF9C',
  '--color-dark-primary': '#E7CF9C',
  '--color-secondary': '#9C5C1C',
  '--color-navigation-background': '#783F13',
  '--color-light': '#451004',
  '--color-black': '#FFFFFF',
  '--color-background': '#090c0d',
  '--color-verse-index': '#C5C5C5',

  '--color-button-background': '#451004',
  '--color-button-text': '#E7CF9C',
  '--color-button-border': '#E7CF9C',

  '--active-button-background': '#E7CF9C',
  '--active-button-text': '#451004',
  '--active-button-border': '#451004',

  '--color-checkbox-border': '#E7CF9C',
  '--color-checkbox-background': '#DBB86B',
  '--color-checkbox-accent': '#E7CF9C',

  '--color-verse-underline': '#FFFFFF',
}

function createA11yTheme(background: string, color: string) {
  return {
    '--color-white': background,
    '--color-primary': color,
    '--color-wood': background,
    '--color-borderColor': color,
    '--color-dark-primary': background,
    '--color-secondary': color,
    '--color-navigation-background': background,
    '--color-light': color,
    '--color-black': color,
    '--color-background': background,
    '--color-verse-index': color,

    '--color-button-background': background,
    '--color-button-text': color,
    '--color-button-border': color,

    '--active-button-background': color,
    '--active-button-text': background,
    '--active-button-border': background,

    '--color-checkbox-border': color,
    '--color-checkbox-background': background,
    '--color-checkbox-accent': color,

    '--color-verse-underline': color,
  }
}

function applyTheme(theme: any) {
  const root = document.documentElement
  for (const [key, value] of Object.entries(theme)) {
    // @ts-ignore
    root.style.setProperty(key, value)
  }
}

export function applyBibleFontFamily(fontFamily: string) {
  const root = document.documentElement
  root.style.setProperty('--bible-font-family', fontFamily)
}

export function getBibleFontFamily() {
  const root = document.documentElement
  return getComputedStyle(root).getPropertyValue('--bible-font-family')
}

export function applyA11yTheme(background: string, color: string, mode = '') {
  const theme = mode === 'dark' ? createA11yTheme(color, background) : createA11yTheme(background, color)
  applyTheme(theme);
}

export function applyDefaultTheme(mode: 'light' | 'dark' = 'light') {
  const theme = mode === 'dark' ? darkTheme : defaultTheme
  applyTheme(theme)
}

// only exported colors that use
export const colors = {
  white: 'var(--color-white)',
  primary: 'var(--color-primary)',
  wood: 'var(--color-wood)',
  darkPrimary: 'var(--color-dark-primary)',
  borderColor: 'var(--color-borderColor)',
  secondary: 'var(--color-secondary)',
  navigationBackground: 'var(--color-navigation-background)',
  light: 'var(--color-light)',
  black: 'var(--color-black)',
  background: 'var(--color-background)',
  verseIndexColor: 'var(--color-verse-index)',

  buttonBackground: 'var(--color-button-background)',
  buttonText: 'var(--color-button-text)',
  buttonBorder: 'var(--color-button-border)',

  verseUnderline: 'var(--color-verse-underline)',
}
